import {
  catchError,
  from,
  map,
  mergeMap,
  of,
  type OperatorFunction,
} from 'rxjs';
import { type PayloadAction } from '@reduxjs/toolkit';
import { type RequestActionCreator } from '@/types';

export const request = <P, S, R extends S>(
  requestCreator: (action: any) => Promise<R>,
  responseAction: RequestActionCreator<P, S>,
): OperatorFunction<PayloadAction<P>, PayloadAction<any>> =>
  mergeMap((action) =>
    from(requestCreator(action)).pipe(
      map((data) =>
        responseAction.succeeded({
          data,
          originalData: action?.payload,
        }),
      ),
      catchError((error) => of(responseAction.failed(error?.response?.data))),
    ),
  );
